// extracted by mini-css-extract-plugin
module.exports = {"root":"DebugHelper_root__1bzlp","bounceIn":"DebugHelper_bounceIn__3mgMO","title":"DebugHelper_title__IuCkF","event_id":"DebugHelper_event_id__2G9QF"};